import React, { useState } from "react";
import { doPost } from "../../API/apis";
import { useStateGlobalContext } from "../../contexts/GlobalContext";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import Notification from "../Notification/Notification";
import FormatDate from "../FormatDate/FormatDate";
import LabelDisplay from "../LabelDisplay/LabelDisplay";
import ProductCheckout from "../ProductCheckout/ProductCheckout";
import { discountCalulator } from "../../utils/validator";

const BuyProducts = ({
  visible,
  onClose,
  fullName,
  mrn_number,
  date_of_birth,
}) => {
  const { id } = useParams();
  const { getProductInvoices } = useStateGlobalContext();
  const [saving, setSaving] = useState(false);
  const currentDate = dayjs().format("MM/DD/YYYY");

  const handleCheckout = async ({
    productList,
    totalPriceBeforeTax,
    totalPriceAfterTax,
    discount,
    discountApplied,
    calcTax,
    form,
  }) => {
    setSaving(true);
    
    try {
      const discountValue = discountApplied
        ? discountCalulator(discount, totalPriceBeforeTax)
        : 0;

      const data = {
        mrn_number: mrn_number,
        patient_name: fullName,
        dob: date_of_birth,
        product_details: productList,
        discount: discount,
        discounted_amount: discountValue,
        tax: calcTax(totalPriceBeforeTax),
        price: totalPriceBeforeTax,
        total_price: totalPriceAfterTax,
        notes: form.getFieldValue("notes"),
        payment_method: form.getFieldValue("payment_method"),
        status: "Paid",
      };

      const response = await doPost(`/inventory/add-prod-invoice/${id}/`, data);
      if (response.status === 201) {
        Notification.success("Product Invoice Created Successfully");
        getProductInvoices(id);
        return true;
      }
    } catch (error) {
      Notification.error("Something went Wrong");
      throw error;
    } finally {
      setSaving(false);
    }
  };

  return (
    <ProductCheckout
      visible={visible}
      onClose={onClose}
      title="Buy Products"
      onCheckout={handleCheckout}
      isGuest={false}
      showStrength={true}
      saving={saving}
    >
      {/* Patient Information Header */}
      <LabelDisplay title="Full Name" description={fullName} />
      <LabelDisplay
        title="DOB"
        description={<FormatDate date={date_of_birth} />}
      />
      <LabelDisplay title="Date" description={currentDate} />
    </ProductCheckout>
  );
};

export default BuyProducts;
